import { type SupportedLanguage, SupportedLanguages } from '@centric-os/platform/i18n';

export enum LookerLocales {
  FRENCH = 'fr_CA',
  ENGLISH = 'en',
}

export type LookerLocale = `${LookerLocales}`;

// https://cloud.google.com/looker/docs/supported-user-interface-languages
export const SUPPORTED_LANGUAGE_TO_LOOKER_LOCALE: Record<SupportedLanguage, LookerLocale> = {
  [SupportedLanguages.FRENCH]: LookerLocales.FRENCH,
  [SupportedLanguages.ENGLISH]: LookerLocales.ENGLISH,
};
